import styled, { css } from 'styled-components';

import {
  Modal as modal,
  ModalHeader as modalHeader,
  ModalBody as modalBody,
} from 'reactstrap';

export const ModalHeader = styled(modalHeader)`
  color: ${({ theme }) => theme.colors.semantic.text.primary};

  .close {
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
    text-shadow: none;
  }

  ${({ hastitle }) =>
    !hastitle &&
    css`
      padding: 1rem 1rem 0 0;
      border-bottom: none;
    `}
`;

export const ModalBody = styled(modalBody)`
  color: ${({ theme }) => theme.colors.semantic.text.primary};

  ${({ hastitle }) =>
    !hastitle &&
    css`
      padding-top: 0;
    `}
`;

export const Modal = styled(modal)`
  .modal-content {
    background: ${({ theme }) => theme.colors.semantic.surface.card};
    border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
    color: ${({ theme }) => theme.colors.semantic.text.primary};
  }

  .modal-header {
    border-bottom-color: ${({ theme }) => theme.colors.semantic.border.default};
  }

  .modal-footer {
    border-top-color: ${({ theme }) => theme.colors.semantic.border.default};
  }

  &.modal-2xl {
    max-width: 1400px;
  }

  ${props =>
    props.$fullscreen &&
    css`
      padding: 0;
      position: fixed;
      width: calc(100vw - 16px);
      height: calc(100vh - 16px);
      z-index: 9999;
      margin: 8px;

      .modal-content {
        width: calc(100vw - 16px);
        height: calc(100vh - 16px);
        display: flex;
        flex-direction: column;
      }

      .modal-body {
        flex: 1;
        overflow: hidden;
        padding: 1rem;
      }

      /* Remove classes de tamanho padrão */
      &.modal-sm,
      &.modal-lg,
      &.modal-xl {
        .modal-dialog {
          max-width: calc(100vw - 16px);
        }
      }
    `}
`;
